




import {Vue, Component} from 'vue-property-decorator'

import BroadcastDetail  from '@/components/BroadcastDetail.vue'

@Component({
  components: {
      BroadcastDetail
  }
})
export default class BroadcastDetailView extends Vue {
}
